import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import logo from './logo-full.svg';
import './HarleyDavidsonLogo.css';
import { useIwaContext } from '@cognitranlimited/itis-web';
export var HarleyDavidsonLogo = function () {
    var strings = useIwaContext().strings;
    return _jsx("img", { className: "HarleyDavidsonLogo", src: logo, alt: strings.app.name });
};
